export const DEFAULT_CARD_PRESENTATION = Object.freeze({
  version: 1,
  variant: 'standard',
  media_treatment: 'inline',
  eyebrow: '',
  headline: '',
  rationale: '',
  badge: '',
})

export function normalizeCardPresentation(value) {
  if (!value || typeof value !== 'object' || Object.keys(value).length === 0) return null
  const normalized = { ...DEFAULT_CARD_PRESENTATION, ...value }
  delete normalized.accent
  delete normalized.show_event_timeline
  return normalized
}
